import moment from 'moment';

export default function convertTimeToUTC(dateTime) {
	var result = moment
		.tz(dateTime, 'MM-DD-YYYY HH:mm:ss', moment.tz.guess())
		.utc()
		.format();
	return result;
}



// WEBPACK FOOTER //
// ./src/core/utils/convertTimeToUTC.js